module.exports = __webpack_public_path__ + "img/farming_39.3f276c1d.png";